/** @format */

import React, { useState, useCallback } from 'react';
import {
	MenuGroupWrapper,
	MenuGroupContainer,
	MenuVectorWrapper
} from '../../styles';
import { Trans } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import VectorDown from '../../../../../images/img/vectorDown.svg';
import Link from '../../../Link';

const MenuGroup = ({ i18nKey, defaultOpen, children, path }) => {
	const [open, setOpen] = useState(defaultOpen ? defaultOpen : false);
	const toggleOpen = useCallback(() => {
		setOpen(!open);
	}, [open, setOpen]);

	return (
		<>
			<MenuGroupWrapper active={!open && children.length > 0}>
				<span>
					<Link path={path}>
						<Trans i18nKey={i18nKey} />
					</Link>
				</span>
				{children.length > 0 && (
					<CSSTransition
						in={open} // 用於判斷是否出現的狀態
						timeout={1000} // 動畫持續時間
						classNames="rotate-vector">
						<MenuVectorWrapper
							onClick={toggleOpen}
							src={VectorDown}
							width="8"
							height="8"
						/>
					</CSSTransition>
				)}
			</MenuGroupWrapper>
			<CSSTransition
				in={open} // 用於判斷是否出現的狀態
				timeout={1000} // 動畫持續時間
				classNames="menu-group">
				<MenuGroupContainer>{children}</MenuGroupContainer>
			</CSSTransition>
		</>
	);
};

export default React.memo(MenuGroup);
